module.exports = __webpack_public_path__ + "static/media/first-direct.23047f04.svg";